import { InfoCircleOutlined } from "@ant-design/icons";
import styles from "./buildmate.module.css";


function CancelBuildMatePayment() {
  return (
    <div>
      <div className={styles.payment}>
        <div className={styles.card}>
          <span data-error className={styles.icon}>
            <InfoCircleOutlined />
          </span>
          <h1>Payment was cancelled</h1>
          <div>
            <p>
              We noticed your payment for the order was canceled. Was there a problem completing the payment, or did you choose to cancel for another reason?
            </p>
            <br />
            <p>If you need help, please contact Buildmate:</p>
            <br />
            <ul>
              <li>
                Email: <a href="mailto:info@materialspro.ng">info@materialspro.ng</a>
              </li>
              <li>
                Phone: <a href="tel:+23409165407978">09165407978 </a>
              </li>
            </ul>
            <br />
            <p>We&apos;re happy to assist.</p>
          </div>
          <a href="#cancel" className={styles["back-btn"]}>
            Go back
          </a>
        </div>
      </div>
    </div>
  );
}

export default CancelBuildMatePayment